var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvaluation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7,14.2c0.2,0,0.4-0.1,0.6-0.2c0.2-0.2,0.2-0.4,0.2-0.6V9.2c0-0.2-0.1-0.4-0.2-0.6C7.1,8.4,6.9,8.3,6.7,8.3 S6.2,8.4,6.1,8.6C5.9,8.7,5.8,8.9,5.8,9.2v4.2c0,0.2,0.1,0.4,0.2,0.6C6.2,14.1,6.4,14.2,6.7,14.2z M10,14.2c0.2,0,0.4-0.1,0.6-0.2 c0.2-0.2,0.2-0.4,0.2-0.6V6.7c0-0.2-0.1-0.4-0.2-0.6c-0.2-0.2-0.4-0.2-0.6-0.2S9.6,5.9,9.4,6.1S9.2,6.4,9.2,6.7v6.7 c0,0.2,0.1,0.4,0.2,0.6C9.6,14.1,9.8,14.2,10,14.2z M13.3,14.2c0.2,0,0.4-0.1,0.6-0.2c0.2-0.2,0.2-0.4,0.2-0.6v-1.7 c0-0.2-0.1-0.4-0.2-0.6c-0.2-0.2-0.4-0.2-0.6-0.2s-0.4,0.1-0.6,0.2s-0.2,0.4-0.2,0.6v1.7c0,0.2,0.1,0.4,0.2,0.6 C12.9,14.1,13.1,14.2,13.3,14.2z M4.2,17.5c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.7-0.5-1.2V4.2C2.5,3.7,2.7,3.3,3,3 c0.3-0.3,0.7-0.5,1.2-0.5h11.7c0.5,0,0.9,0.2,1.2,0.5c0.3,0.3,0.5,0.7,0.5,1.2v11.7c0,0.5-0.2,0.9-0.5,1.2c-0.3,0.3-0.7,0.5-1.2,0.5 H4.2L4.2,17.5z M4.2,15.8h11.7V4.2H4.2L4.2,15.8L4.2,15.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaluation);
export default __webpack_public_path__ + "static/media/Evaluation.2da9867a304384a8d79c0b4bc3d37c9d.svg";
export { ForwardRef as ReactComponent };